import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
// import App from './App';
import AppCorrespondencia from './App-correspondencia';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        {/* <App /> */}
        <AppCorrespondencia />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
